
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 18a.5.5 0 01-.5-.5V7.2a.5.5 0 011 0v10.3a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M16 11a.5.5 0 01-.354-.146L12 7.207l-3.647 3.647a.5.5 0 01-.707-.707l4-4a.5.5 0 01.707 0l4 4A.5.5 0 0116 11z"}}),_c('path',{attrs:{"d":"M12 24a12 12 0 1112-12 12.013 12.013 0 01-12 12zm0-23a11 11 0 1011 11A11.012 11.012 0 0012 1z"}})])
          )
        }
      }
    